import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PermissionsPipe } from './permissions.pipe';

@NgModule({
  declarations: [PermissionsPipe],
  imports: [CommonModule],
  exports: [PermissionsPipe],
})
export class PermissionsModule {}
